define('views/modules/conversation/message/new-message-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    'services/user',
    // views
    'views/parts/menu/menu-context',
    'views/modules/supervisor/supervisor-icon',
    'views/parts/form/button',
    'views/modules/conversation/message/reply-list',
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-list',
    'views/modules/conversation/message/message-list-item',
    // collections
    'collections/conversation/messages',
    'collections/calendar/items',
    // templates
    'text!templates/modules/conversation/message/message-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    i18n,
    User,
    // views
    VMenuContext,
    VSupervisorIcon,
    VButton,
    VReplyList,
    VCalendarItemList,
    VMessageListItem,
    // collections
    CMessages,
    CCalendarItems,
    // templates
    TMessageListItem
) {

    var VNewMessageListItem = VMessageListItem.extend({

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                activity = new CCalendarItems(model.getActivity());

            _.extend(this, {
                view: {},
                replies: new CMessages(model.getReplies()),
                conversations: opt.conversations
            });

            this.replies.setUsers(this.conversations.getUsers());

            if (this.replies.length) {
                this.replies.prepareCollection();
            }

            _.extend(this, {
                timestamp: model.getTimeStampObject(),
                supervisors: opt.supervisors
            });

            this.listenTo(model, {
                'active': this.setActive,
                'remove': this.remove,
            });
        },

        render: function() {
            var model = this.model;
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(_.extend(this.model.toJSON(), {
                isSupervisor: this.userIsSupervisor(),
                isReply: Boolean(model.get('parentId')),
                isConnectedUser: model.getUser() === User.id
            })), {
                date: this.getTemplatedTimestamp(),
            }));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.renderSupervisorIcon();

            this.applyBindings();

            return this;
        },

        onConversationsSync: function(collection) {
            var replies = this.replies;
            replies.setUsers(collection.getUsers());
            replies.prepareCollection();
        },

        ////////////
        // events //
        ////////////

    });

    return VNewMessageListItem;
});

